import renderNothing from 'react-recompose/renderNothing';
import panelStyles from '../components/panel.less';
import { ErrorBoundary } from 'react-error-boundary';

import { Timebars } from './timebar';
import { Settings } from './settings';
import { InspectorTable } from './InspectorTable';
import { Histograms } from './histograms';
import { Expressions } from './expressions';
import { ErrorFallback } from '../components/ErrorFallback';
import { container } from '@graphistry/falcor-react-redux';
import { createLogger } from '@graphistry/common/logger';
import { CollectionsComponent } from '../components/collections/index.tsx';
const logger = createLogger(__filename);

const panelsById = {
    scene: Settings,
    layout: Settings,
    labels: Settings,
    timebars: Timebars,
    filters: Expressions,
    inspector: InspectorTable,
    histograms: Histograms,
    exclusions: Expressions,
    collections: CollectionsComponent
};

function componentForSideAndType(side, id) {
    if (!id) {
        return renderNothing();
    }
    return panelsById[id] || (side === 'left' ? Settings : renderNothing());
}

function PanelInner({ panel = {}, className = '', id, side, isOpen, name, style, ...props }) {
    const Component = componentForSideAndType(side, panel.id);
    return (<ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(exn) => {
            logger.error({exn}, 'Panel error');
        }}
        onReset={() => {
        // reset the state of your app so the error doesn't happen again
        }}>
        <Component
            data={panel}
            style={style}
            id={panel.id}
            name={name}
            side={side}
            className={className + ' ' + panelStyles[`panel-${side}`]}
            {...props}
        />
    </ErrorBoundary>);
}

const Panel = container({
    renderLoading: true,
    fragment: (fragment = {}, props) => {
        const Content = componentForSideAndType(props.side, fragment.id);
        if (!Content || !Content.fragment) {
            return `{ id, name }`;
        }
        return Content.fragment(fragment, props);
    },
    mapFragment: panel => ({ panel })
})(PanelInner);

export { Panel };
